module.exports = __webpack_public_path__ + "static/media/chapul-large-blog2.1f161753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/chapul/chapul-large-blog2.jpg
// module id = 670
// module chunks = 0